import React from 'react';
import {Icon, Text} from '@albert-io/atomic';
import {ANNOTATION_SHIELD_EXEMPT_PROPS} from 'client/components/PracticeView/Annotations/shared/annotationFreeze';
import {PlaybackRateMenu, formatPlaybackRate} from './PlaybackRateMenu';
import './audio-player.scss';

interface AudioControlsProps {
  isPlaying: boolean;
  playbackRate: number;
  togglePlayPause: () => void;
  restartAudio: () => void;
  selectPlaybackRate: (rate: number) => void;
}

const AudioControls = ({
  isPlaying,
  playbackRate,
  togglePlayPause,
  restartAudio,
  selectPlaybackRate
}: AudioControlsProps) => {
  return (
    // Shield-exempt: playback stays usable while annotation mode freezes the question.
    <div {...ANNOTATION_SHIELD_EXEMPT_PROPS} className='audio-player__buttons-group'>
      <button
        type='button'
        className='audio-player__button type-1'
        onClick={restartAudio}
        aria-label='restart audio'
        data-testid='audio-controls__restart-audio'
      >
        <Icon className='audio-player__button-icon' icon='backward-step' />
      </button>
      <button
        type='button'
        className='audio-player__button type-2'
        onClick={togglePlayPause}
        aria-label={isPlaying ? 'pause' : 'play'}
        data-testid='audio-controls__play-pause'
      >
        <Icon
          color='primary-inverse'
          className='audio-player__button-icon-play-pause'
          icon={isPlaying ? 'pause' : 'play'}
        />
      </button>
      <PlaybackRateMenu
        playbackRate={playbackRate}
        onSelectRate={selectPlaybackRate}
        renderTrigger={(triggerProps) => (
          <button
            {...triggerProps}
            type='button'
            className='audio-player__button type-1'
            aria-label='change playback rate'
            data-testid='audio-controls__change-playback-rate'
          >
            <Text className='audio-player__button-icon' bold color='primary'>
              {formatPlaybackRate(playbackRate)}
            </Text>
          </button>
        )}
      />
    </div>
  );
};

export default AudioControls;
